export class LoadingState {
  /** @type {boolean} */
  isLoading = false;

  start() {
    this.isLoading = true;
  }

  stop() {
    this.isLoading = false;
  }
}

/**
 * Base class for components that use template-based slot rendering
 * Templates should have data-slot="slotName" attributes
 */
export class SlottedTemplate extends HTMLElement {
  /** @type {Map<string, HTMLTemplateElement>} */
  slots = new Map();

  /** @type {HTMLElement} */
  outputContainer;

  constructor() {
    super();

    // Collect all template slots
    const templates = this.querySelectorAll('template[data-slot]');
    templates.forEach(template => {
      const slotName = template.getAttribute('data-slot');
      if (slotName) {
        this.slots.set(slotName, /** @type {HTMLTemplateElement} */ (template));
      }
    });

    // Find or create output container
    this.outputContainer = this.querySelector('[data-slot-output]');
    if (!this.outputContainer) {
      this.outputContainer = document.createElement('div');
      this.outputContainer.setAttribute('data-slot-output', '');
      this.appendChild(this.outputContainer);
    }
  }

  /**
   * Renders a specific slot by name
   * @param {string} slotName - The name of the slot to render
   * @returns {DocumentFragment | null}
   */
  getSlotContent(slotName) {
    const template = this.slots.get(slotName);
    if (!template) {
      console.warn(`Slot "${slotName}" not found`);
      return null;
    }
    return template.content.cloneNode(true);
  }

  /**
   * Renders a slot into the output container
   * @param {string} slotName - The name of the slot to render
   */
  renderSlot(slotName) {
    const content = this.getSlotContent(slotName);
    if (content) {
      this.outputContainer.innerHTML = '';
      this.outputContainer.appendChild(content);
    }
  }
}